<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue';
import { RouterView } from 'vue-router';
// import { showLoadingToast } from 'vant';
import { isApp, isCrawler, loginByApp } from '@/utils/tools';
import { v4 as uuidv4 } from 'uuid';
import dayjs from 'dayjs';
import { registerAlive } from '@/api/identify';
import { useDeviceStore, usePositioningStore } from '@/stores';
import { isKeXieApp, loginByKeXieApp } from '@/utils/ccwork';

const positioningStore = usePositioningStore();
const deviceStore = useDeviceStore();

// persist 插件只在 state 变更时写存储，应用入口显式持久化一次，
// 保证初始化生成的设备id跨会话稳定
deviceStore.$persist();

// #region ‼️这些代码必须放在文件最前面，不要改动位置！！！

// 解决安卓和Safari浏览器地址栏显示隐藏的问题
onMounted(() => {
  calcHeight();
  window.addEventListener('resize', calcHeight);
  // iOS 键盘收起时 window.resize 有时不触发，--vh 会停在键盘撑起时的高度，
  // 补一个视觉视口监听（键盘显隐必触发）兜底
  window.visualViewport?.addEventListener('resize', calcHeight);
  positioningStore.setDefProvince();
});
onUnmounted(() => {
  window.removeEventListener('resize', calcHeight);
  window.visualViewport?.removeEventListener('resize', calcHeight);
});
const calcHeight = () => {
  // 取视觉视口高度：iOS 键盘弹起时 window.innerHeight（布局视口）不一定跟着变，
  // 页面会比可视区域高，系统为了露出输入框会把整页往上顶（输入框被顶出屏幕）
  const vh = window.visualViewport?.height ?? window.innerHeight;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
};

// #endregion

// app自动登录
const isLoginReady = ref(false);
async function appAutoLogin() {
  try {
    if (isApp()) {
      // 科普中国app
      await loginByApp(false);
    } else if (isKeXieApp()) {
      // 智慧科协app
      await loginByKeXieApp(false);
    }
  } catch (error) {
    console.error('自动登录失败:', error);
    // 即使登录失败，也要继续渲染页面
  }
  isLoginReady.value = true;
  console.log('🚀 ~ appAutoLogin ~ isLoginReady:', isLoginReady);
}
appAutoLogin();

// showLoadingToast({
//   message: '加载中...',
//   forbidClick: true,
// });

//统计活跃量
function saveAliveInfo() {
  const day = dayjs().format('YYYY-MM-DD');
  const identifyKey: string = localStorage?.getItem('identifyKey') || '';
  if (identifyKey) {
    const keysArr = identifyKey.split('#');
    if (keysArr.length > 0 && keysArr[1] != day) {
      localStorage?.setItem('identifyKey', keysArr[0] + '#' + day);
      sendAliveMsg(keysArr[0]);
    }
  } else {
    const uuid = uuidv4();
    localStorage?.setItem('identifyKey', uuid + '#' + day);
    sendAliveMsg(uuid);
  }
}
if (!isCrawler()) {
  saveAliveInfo();
}
//发送活跃数据
async function sendAliveMsg(key: string) {
  try {
    await registerAlive({
      unique_identifier: key,
    });
  } catch (error) {
    console.log((error as HttpResponse).errorMsg);
  }
}
</script>

<template>
  <RouterView v-if="isLoginReady" v-slot="{ Component }">
    <KeepAlive>
      <component :is="Component" v-if="$route.meta.keepAlive" />
    </KeepAlive>
    <component :is="Component" v-if="!$route.meta.keepAlive" />
  </RouterView>
</template>
